import { mdiCheckCircle, mdiChevronDown, mdiChevronRight, mdiChevronUp } from '@mdi/js';
import Icon from '@mdi/react';
import get from 'lodash/get';
import Lottie from 'lottie-light-react';
import { bool, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { connect, useDispatch, useSelector } from 'react-redux';
import { SET_NEWSLETTER_LIST } from '../../../../../store/actions';
import { SOCIAL_SHARE } from '../../../../constants';
import { getSSOLoginUrl, getSSORedirectUrl } from '../../../../helpers/subscription-helper';
import { makeApiCall } from '../../../../helpers/utils';
import { BQLink } from '../../../atoms/bqlink';
import Loader from '../../../atoms/icons/loader';
import Notify from '../notify';
import SuccessLottie from '../notify/lottie-mail-alert.json';
import './mailmodo-news-letter.m.css';
import { newsLetterDl } from '../../../../helpers/datalayer-utils';

let isEffectExecuted = false;

const MailmodoNewsletter = ({ fullWidth, espConfig, page, integrations, section, customClass = '' }) => {
  const dispatch = useDispatch();
  const newsLetterList = useSelector((state) => get(state, ['newsletter'], {}));
  const [notSubscribed, setNotSubscribed] = useState([]);
  const [subscribed, setSubscribed] = useState([]);
  const [displayLetter, setDisplayLetter] = useState({});
  const isLoggedIn = useSelector((state) => get(state, ['userData', 'isLoggedIn'], null));
  const userInfo = useSelector((state) => get(state, ['userData', 'userProfile'], null));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );
  const SSO_PROFILE_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'profile_url'], null),
  );
  const [isProcessing, setIsProcessing] = useState(false);
  const [showNotify, setShowNotify] = useState(false);
  const [notifyMode, setNotifyMode] = useState('');
  const [notifyUrl, setNotifyUrl] = useState('');
  const [notifyTitle, setNotifyTitle] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const baseUrl = espConfig?.base_url;
  const modalRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const sortedLetters = [...(newsLetterList?.list || [])].sort((a, b) => {
      return a?.order?.story - b?.order?.story;
    });
    const allNotSubscribed = sortedLetters?.filter((l) => !l.subscribed);
    setNotSubscribed(allNotSubscribed);
    const allSubscribed = sortedLetters?.filter((l) => l.subscribed);
    setSubscribed(allSubscribed);
    if (allNotSubscribed.length > 0) {
      setDisplayLetter(allNotSubscribed[0]);
    } else {
      setDisplayLetter(allSubscribed[0]);
    }
  }, [newsLetterList]);
  useEffect(() => {
    if (!isEffectExecuted) {
      if (userInfo?.email) {
        isEffectExecuted = true;
        const storageItem = window.localStorage.getItem('storyNewsletter');
        if (!!storageItem) {
          const newsletter = JSON.parse(storageItem);
          if (newsletter) {
            setNotifyTitle(newsletter.title);
            const subscriptionUrl = `${baseUrl}/api/v1/addToList`;
            const payload = generatePayload(newsletter);
            addToList(subscriptionUrl, payload, newsletter, true);
          }
        }
      }
    }
  }, [newsLetterList]);

  const signIn = (list) => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((redirectUrl) => {
      getSSOLoginUrl(
        integrations?.sso?.client_id,
        integrations?.sso?.client_secret,
        redirectUrl,
        SSO_LOGIN_URL,
      ).then((pageUrl) => {
        setIsProcessing(false);
        window.localStorage.setItem('storyNewsletter', JSON.stringify(list));
        window.location = pageUrl;
      });
    });
  };

  const generatePayload = (list) => {
    return {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, application/xml',
        mmApiKey: espConfig?.api_key,
      },
      body: `{ "email": "${userInfo?.email}", "listName": "${espConfig?.[list?.id]}", "data": { "${list?.data_key}": "${!list?.subscribed}" } }`,
    };
  };

  const addToList = (subscriptionUrl, payload, list, fromStorage = false) => {
    if (fromStorage) {
      const letter = newsLetterList?.list?.find((l) => l.id === list.id);
      if (letter?.subscribed) {
        window.localStorage.removeItem('storyNewsletter');
        toast.custom(
          <div styleName="subscribe-toast-ctx">
            <div styleName="subscribe-toast">
              <Lottie
                animationData={SuccessLottie}
                loop={true}
                autoplay={true}
                style={{ width: '20px', height: '20px', transform: 'scale(4)', marginLeft: 4 }}
              />
            </div>
            &nbsp;&nbsp;
            <div style={{ textAlign: 'center' }}>
              You’re&nbsp;<b>already</b>&nbsp;in the Mailing List
            </div>
          </div>,
          { id: 'already-subscribed' },
        );
        return;
      }
    }
    makeApiCall(subscriptionUrl, 'POST', JSON.parse(payload.body), payload.headers).then((res) => {
      setIsProcessing(false);
      if (res?.success) {
        const newState = newsLetterList.list.map((l) => {
          if (l.id === list.id) {
            return { ...l, subscribed: true };
          }
          return l;
        });
        dispatch({ type: SET_NEWSLETTER_LIST, payload: newState });
        if (fromStorage) {
          window.localStorage.removeItem('storyNewsletter');
          setNotifyMode('addNewsletter');
          setShowNotify(true);
        } else {
          toast.custom(
            <div styleName="subscribe-toast-ctx">
              <div styleName="subscribe-toast">
                <Lottie
                  animationData={SuccessLottie}
                  loop={true}
                  autoplay={true}
                  style={{ width: '20px', height: '20px', transform: 'scale(4)', marginLeft: 4 }}
                />
              </div>
              &nbsp;&nbsp;
              <div style={{ textAlign: 'center' }}>
                You’ve subscribed to <b>{list.title} Newsletter</b>
              </div>
            </div>,
          );
          newsLetterDl(userInfo, pageType, section, list.title); // 🚨 critical dataLayer event, Don't remove
        }
      } else {
        toast('Oops. Some Error Occurred. Please try again in some time.');
      }
    });
  };

  const onClickButton = (list) => {
    if (!list.subscribed) {
      setNotifyTitle(list.title);
      setIsProcessing(true);
      const endpoint = list.subscribed ? 'removeFromList' : 'addToList';
      const subscriptionUrl = `${baseUrl}/api/v1/${endpoint}`;
      const payload = generatePayload(list);
      if (!isLoggedIn) {
        signIn(list);
      } else if (isLoggedIn && !userInfo?.email) {
        const url = new URL(window?.location?.href);
        getSSORedirectUrl(url).then((redirectUrl) => {
          getSSOLoginUrl(
            integrations?.sso?.client_id,
            integrations?.sso?.client_secret,
            redirectUrl,
            SSO_PROFILE_URL,
          ).then((pageUrl) => {
            setIsProcessing(false);
            window.localStorage.setItem('storyNewsletter', JSON.stringify(list));
            setNotifyMode('addEmail');
            setNotifyUrl(pageUrl);
            setShowNotify(true);
          });
        });
      } else {
        addToList(subscriptionUrl, payload, list);
      }
    }
  };

  return (
    <React.Fragment>
      <div
        styleName={`mailmodo-wrapper ${page === 'footer' ? 'outline' : fullWidth ? 'full-width-wrap' : ''} ${customClass}`}
      >
        <BQLink styleName="mm-title" href={SOCIAL_SHARE?.NEWSLETTER} target="_blank">
          <div>OUR NEWSLETTERS</div> <Icon path={mdiChevronRight} size="20px" color="#8F9DA5" />
        </BQLink>
        <div styleName={fullWidth ? 'main-wrapper horizontal-wrap' : 'main-wrapper'}>
          <div
            ref={modalRef}
            styleName={isOpen ? 'mm-list highlight' : 'mm-list'}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div styleName="icon">
              <iframe
                src="https://lottie.host/embed/de824d24-3599-4acf-9e1b-86fb7e9f1588/gO7py3xyyS.lottie"
                style={{ border: 'none', width: '44px', height: '44px' }}
                title="Newsletter Animation"
                allow="autoplay"
              ></iframe>
            </div>
            <div styleName="mm-heading">
              <div styleName="mm-text">
                <span>{displayLetter?.title}</span>
                <div styleName="text">{displayLetter?.subTitle}</div>
              </div>
              <Icon
                path={!isOpen ? mdiChevronDown : mdiChevronUp}
                size="20px"
                color={!isOpen ? '#B8BFC3' : '#2b2b2b'}
              />
            </div>
            {isOpen && (
              <div styleName="newsletter-list">
                {notSubscribed?.length > 0 && (
                  <div styleName="not-subscribed-ctx">
                    <div styleName="not-subscribed-title">
                      NOT SUBSCRIBED ({notSubscribed?.length})
                    </div>
                    {notSubscribed?.map((l) => (
                      <div
                        styleName={`not-subscribed-list ${displayLetter?.id === l?.id ? 'selection' : ''}`}
                        onClick={() => setDisplayLetter(l)}
                      >
                        <div styleName="list-title">{l?.title}</div>
                        <div styleName="list-subtitle">{l?.subTitle}</div>
                      </div>
                    ))}
                  </div>
                )}
                {subscribed?.length > 0 && (
                  <React.Fragment>
                    {notSubscribed?.length !== 0 && <div styleName="divider"></div>}
                    <div styleName="subscribed-ctx">
                      <div styleName="subscribed-title">SUBSCRIBED ({subscribed?.length})</div>
                      {subscribed?.map((l) => (
                        <div
                          styleName={`subscribed-list ${displayLetter?.id === l?.id ? 'selection' : ''}`}
                          onClick={() => setDisplayLetter(l)}
                        >
                          <div styleName="list-title">{l?.title}</div>
                          <div styleName="list-subtitle">{l?.subTitle}</div>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
          <div
            styleName={`subscribe-cta ${displayLetter?.subscribed ? 'active' : ''}`}
            onClick={() => onClickButton(displayLetter)}
          >
            {displayLetter?.subscribed && (
              <Icon
                path={mdiCheckCircle}
                size="20px"
                color={`${fullWidth ? '#FFFFFF' : '#14C588'}`}
              />
            )}
            {displayLetter?.subscribed ? (
              fullWidth ? (
                'Subscribed'
              ) : (
                "You've already signed up"
              )
            ) : isProcessing ? (
              <Loader color={`var(--white)`} width="30" />
            ) : (
              'Sign Up'
            )}
          </div>
        </div>
        <div styleName={fullWidth ? 'mm-desc text-align' : 'mm-desc'}>
          {displayLetter?.subscribed && fullWidth ? (
            <React.Fragment>
              <em style={{ fontWeight: 700 }}>You’ve successfully signed up</em> to the mailing list
            </React.Fragment>
          ) : (
            <React.Fragment>
              By signing up you agree to the{' '}
              <BQLink styleName="link" href="/terms-of-use" target="_blank">
                Terms & Conditions
              </BQLink>{' '}
              {!fullWidth && <br />}of NDTV Profit
            </React.Fragment>
          )}
        </div>
      </div>
      {showNotify && (
        <Notify mode={notifyMode} url={notifyUrl} setter={setShowNotify} title={notifyTitle} />
      )}
    </React.Fragment>
  );
};

MailmodoNewsletter.propTypes = {
  fullWidth: bool,
  page: string,
  section: string,
};
MailmodoNewsletter.defaultProps = {
  fullWidth: false,
  page: null,
  section: 'newsletter-widget',
};

export default connect((state) => ({
  espConfig: get(state, ['qt', 'config', 'integrations', 'esp_config'], null),
  integrations: state.qt.config['integrations'],
}))(MailmodoNewsletter);
